import isRestaurant from '@shopDetails/utils/isRestaurant';
import { successAction } from '@utils/actions';
import { errorAction, redirect } from '@shared/actions';
import { isNullOrUndefined } from '@utils/object';
import getShopBusinessType from '@core/reducers/shop/selectors/getShopBusinessType';
import getOptionsGroups from '@services/menu/getOptionsGroups';
import { mapProducts } from '@models/ShopDetails';
import * as actions from '../actionTypes';
import getShopDetailsRoute from '../utils/getShopDetailsRoute';

const fetchProductOptions = ({
  productId,
  shopId,
  isFavourite = false,
  itemId = null,
  subsidizedProduct = null,
  price = null,
  discount = null,
}) => async (dispatch, getState, axios) => {
  const type = actions.FETCH_PROD_OPTIONS;
  try {
    const state = getState();
    const businessType = getShopBusinessType(state);
    const menuWithNiles = isRestaurant(businessType);

    dispatch({ type });

    const { success, data, error } = await getOptionsGroups({
      axios,
      productId,
      shopId,
    });

    if (success) {
      const product = Array.isArray(data) ? data[0] : data;
      const response = { ...product, isFavourite, itemId };

      // Forwarded the price with the discount applied from niles API
      if (menuWithNiles && !isNullOrUndefined(price)) {
        response.subsidizedProduct = subsidizedProduct;
        response.price = price;
        response.applyDiscount = false;
        response.discount = discount;
      }

      if (response) {
        dispatch(
          successAction({
            type,
            payload: { product: mapProducts([response])[0] },
          }),
        );
        return;
      }

      dispatch(
        successAction({
          type,
          payload: { product: response },
        }),
      );
    } else {
      dispatch(redirect(getShopDetailsRoute()));
      dispatch(errorAction({ type, error, mute: true }));
    }
  } catch (error) {
    dispatch(errorAction({ type, error }));
  }
};

export default fetchProductOptions;
